import { COVERAGE_URL, TRUSTPILOT_URL } from '../config'

export function ThankYou() {
  return (
    <div className="input-dock">
      <a className="thankyou-cta" href={COVERAGE_URL} target="_blank" rel="noopener noreferrer">
        <span className="thankyou-cta-title">Læs om vores dækninger</span>
        <span className="thankyou-cta-sub">Se hvad bil-, indbo-, hus- og ulykkesforsikring dækker</span>
      </a>
      <a className="thankyou-cta" href={TRUSTPILOT_URL} target="_blank" rel="noopener noreferrer">
        <span className="thankyou-cta-title">Se vores Trustpilot-anmeldelser</span>
        <span className="thankyou-cta-sub">Hør hvad andre kunder siger om Fælles Forsikring</span>
      </a>
    </div>
  )
}
